export const inferredObservability = true;
export default class BadgeComponent extends HTMLElement {
    static get observedAttributes() {
        return ['counter'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        function getValue(value) {
            return value.charAt(0) === '{' || value.charAt(0) === '[' ? JSON.parse(value) : !isNaN(value) ? parseInt(value, 10) : value === 'true' || value === 'false' ? value === 'true' ? true : false : value;
        }
        if (newValue !== oldValue) {
            switch (name) {
            case 'counter':
                this.counter = getValue(newValue);
                break;
            }
            this.render();
        }
    }
    constructor() {
        super();
        this.counter = 0;
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const {counter} = this;
        const condition = ` (${ counter % 2 === 0 ? 'even' : 'odd' }) `;
        this.innerHTML = `<span><span>${ counter }</span><span>${ condition }</span></span>`;
    }
}
customElements.define('wcc-badge', BadgeComponent);